import { FiBriefcase } from 'react-icons/fi';

import Input from '@components/Input';

import { FieldRendererProps } from '../types';

const CnpjField = ({ field, disabled }: FieldRendererProps) => (
  <Input
    name={field.name}
    mask="cnpj"
    placeholder={field.placeholder || field.label || 'CNPJ'}
    icon={FiBriefcase}
    disabled={disabled}
    required={field.is_required}
    inputMode="numeric"
  />
);

export default CnpjField;
